import React from 'react';
import { Box } from '@wix/design-system';
import { UpgradeButton } from './upgrade-button';
import { MainActionButton } from './main-action-button';
import { ContextMenuButton } from '../context-menu-button/context-menu-button';
import type {
  embeddedScriptAppStatus,
  IEmbeddedScriptAppStatus,
  Origin,
} from '../../manage-installed-apps-page';
import type { IModalProps, ModalNames } from '../../modals/modals';
import { canUsePremiumApp, isBundleApp, isSetupIncomplete } from '../../..';
import type { BundleWebSolution } from '@wix/ambassador-marketplace/types';
import type { ManagedApp } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
import { AppGroup } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';

export function AppCTAs({
  app,
  msid,
  origin,
  baseUrl,
  editorType,
  addAppAgain,
  getAppInstance,
  embeddedScriptAppsStatus,
  updateEmbeddedScriptAppsStatus,
  deleteApp,
  mainButtonAction,
  openModal,
  isBusinessApp,
  index,
  gotoWebSolutionPage,
  siteIsPremium,
  isActionRequiredApp,
  openApp,
  deleteAppFromBundle,
  locale,
  siteIsBusinessFirstSite,
  bundleApps,
  isEditorless,
  showUserActionNotification,
  editorUrl,
  authorizationHeader,
  openDeleteModalAppInEditor,
}: {
  app: ManagedApp;
  msid: string;
  origin: Origin;
  baseUrl: string;
  editorType: string;
  isEditorless?: boolean;
  addAppAgain(appDefID: string, appVersion: string): void;
  getAppInstance(appDefId: string): string;
  embeddedScriptAppsStatus: { [key: string]: IEmbeddedScriptAppStatus };
  updateEmbeddedScriptAppsStatus(
    appDefId: string,
    newStatus: embeddedScriptAppStatus,
    appInstanceId: string,
    updateEmbeddedScriptAppsStatus: { [key: string]: IEmbeddedScriptAppStatus },
  );
  deleteApp(app: ManagedApp, showNotification: boolean): void;
  mainButtonAction(app: ManagedApp, bundleApps: BundleWebSolution[]): {} | void;
  openModal(modalName: ModalNames, modalProps: IModalProps): void;
  isBusinessApp: boolean;
  index: number;
  gotoWebSolutionPage(slug: string): void;
  siteIsPremium?: boolean;
  isActionRequiredApp?: boolean;
  openApp?(app: ManagedApp | BundleWebSolution): Promise<{} | void>;
  deleteAppFromBundle?(appId: string): void;
  locale?: string;
  siteIsBusinessFirstSite?: boolean;
  bundleApps: BundleWebSolution[];
  showUserActionNotification?(INotificationsOptions);
  editorUrl?: string;
  authorizationHeader?: any;
  openDeleteModalAppInEditor?(appId: string): void;
}) {
  return (
    <div
      style={{ display: 'flex', alignContent: 'center' }}
      onClick={(e) => e.stopPropagation()}
    >
      {app?.installationDetails?.group !== AppGroup.PENDING &&
        !isEditorless &&
        !isBundleApp(app?.appId, bundleApps) &&
        !isSetupIncomplete(app) &&
        (app?.premiumInfo?.eligibleForUpgrade || isBusinessApp) && (
          <Box
            marginRight={canUsePremiumApp(app, siteIsPremium) ? '12px' : '0'}
          >
            <UpgradeButton
              app={app}
              msid={msid}
              origin={origin}
              isBusinessApp={isBusinessApp}
              editorType={editorType}
              getAppInstance={getAppInstance}
              siteIsPremium={siteIsPremium}
              isActionRequiredApp={isActionRequiredApp}
              locale={locale}
            />
          </Box>
        )}
      {!isEditorless && canUsePremiumApp(app as ManagedApp, siteIsPremium) && (
        <MainActionButton
          mainButtonAction={mainButtonAction}
          app={app}
          msid={msid}
          origin={origin}
          index={index}
          embeddedScriptAppsStatus={embeddedScriptAppsStatus}
          getAppInstance={getAppInstance}
          openModal={openModal}
          isActionRequiredApp={isActionRequiredApp}
          siteIsBusinessFirstSite={siteIsBusinessFirstSite}
          bundleApps={bundleApps}
        />
      )}
      <Box marginLeft="12px">
        <ContextMenuButton
          isEditorless={isEditorless}
          app={app}
          origin={origin}
          addAppAgain={addAppAgain}
          getAppInstance={getAppInstance}
          updateEmbeddedScriptAppsStatus={updateEmbeddedScriptAppsStatus}
          embeddedScriptAppsStatus={embeddedScriptAppsStatus}
          openModal={openModal}
          msid={msid}
          baseUrl={baseUrl}
          gotoWebSolutionPage={gotoWebSolutionPage}
          deleteApp={deleteApp}
          editorType={editorType}
          isActionRequiredApp={isActionRequiredApp}
          openApp={openApp}
          siteIsPremium={siteIsPremium}
          deleteAppFromBundle={deleteAppFromBundle}
          bundleApps={bundleApps}
          locale={locale}
          showUserActionNotification={showUserActionNotification}
          editorUrl={editorUrl}
          authorizationHeader={authorizationHeader}
          openDeleteModalAppInEditor={openDeleteModalAppInEditor}
        />
      </Box>
    </div>
  );
}
